module.exports = __webpack_public_path__ + "img/17400.1e623e24.jpg";